import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import {
  Category,
  CategoryDetails,
  ExclusiveCategoryModel,
  HomeCategories,
  HomeShortcut,
  TopCategoryModel,
} from '../../models/Categories';

interface ICategoryService {
  getCategoryDetails: (
    benefitId: number,
  ) => Promise<HttpResponse<CategoryDetails>>;
  getFixedBenefits: (
    config?: AxiosRequestConfig,
  ) => Promise<HttpResponse<Category>>;
  getFlexibleBenefits: (
    _config?: AxiosRequestConfig,
  ) => Promise<HttpResponse<Category>>;
  getClubBenefits: (
    _config?: AxiosRequestConfig,
  ) => Promise<HttpResponse<Category>>;
  getDiscountVouchers: (
    _config?: AxiosRequestConfig,
  ) => Promise<HttpResponse<Category>>;
  getCashbackSubCategories: (
    _config?: AxiosRequestConfig,
  ) => Promise<HttpResponse<Category>>;
  getTopCategories: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<TopCategoryModel[]>>;
  getExclusiveBenefits: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<ExclusiveCategoryModel[]>>;
  getHomeCategories: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<HomeCategories>>;
  getHomepageShortcuts: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<HomeShortcut[]>>;
}

export const categoryService: ICategoryService = {
  getCategoryDetails(benefitId) {
    return ajax.get<CategoryDetails>(
      `${config.benefitApiUrl}/categories/${benefitId}/details`,
    );
  },
  getFixedBenefits(axiosConfig) {
    return ajax.get<Category>(
      `${config.benefitApiUrl}/categories/my-benefits`,
      axiosConfig,
    );
  },
  getFlexibleBenefits(axiosConfig) {
    return ajax.get<Category>(
      `${config.benefitApiUrl}/categories/flexible-benefits`,
      axiosConfig,
    );
  },
  getClubBenefits(axiosConfig) {
    return ajax.get<Category>(
      `${config.benefitApiUrl}/categories/club-benefits`,
      axiosConfig,
    );
  },
  getDiscountVouchers(axiosConfig) {
    return ajax.get<Category>(
      `${config.benefitApiUrl}/categories/discount-vouchers`,
      axiosConfig,
    );
  },
  getCashbackSubCategories(axiosConfig) {
    return ajax.get<Category>(
      `${config.benefitApiUrl}/categories/cashback`,
      axiosConfig,
    );
  },
  getTopCategories(axiosConfig?): Promise<HttpResponse<TopCategoryModel[]>> {
    return ajax.get<TopCategoryModel[]>(
      `${config.benefitApiUrl}/categories/top`,
      axiosConfig,
    );
  },
  getExclusiveBenefits(
    axiosConfig?,
  ): Promise<HttpResponse<ExclusiveCategoryModel[]>> {
    return ajax.get<ExclusiveCategoryModel[]>(
      `${config.benefitApiUrl}/categories/exclusive_benefits`,
      axiosConfig,
    );
  },
  getHomeCategories(axiosConfig?) {
    return ajax.get<HomeCategories>(
      `${config.benefitApiUrl}/categories/home`,
      axiosConfig,
    );
  },
  getHomepageShortcuts(axiosConfig?) {
    return ajax.get<HomeShortcut[]>(
      `${config.benefitApiUrl}/categories/shortcuts`,
      axiosConfig,
    );
  },
};
